import config from '@/config'
import { round2 } from './math'

export function formatBytes(bytes) {
  if (bytes === 0) {
    return 0
  }
  const units = ['', 'Ki', 'Mi', 'Gi', 'Ti']
  const coef = 1 // = Math.log2(1024 / 512)
  const scale = Math.min(
    Math.floor((Math.log2(bytes) + coef) / 10),
    units.length - 1
  )

  return `${round2(bytes / 1024 ** scale)} ${units[scale]}B`
}

export function formatCurrency(num, currency = 'KRW', options) {
  return num
    ? num.toLocaleString('en-US', {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency,
        ...options,
      })
    : num
}

export function ellipsis(str, length) {
  if (str.length > length) {
    return `${str.slice(0, length)}...`
  }

  return str
}

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function changePath(path) {
  const [accountText, projectText] = [
    config.feature.accountText,
    config.feature.projectText,
  ]
  if (accountText === 'account' || projectText === 'project') return null

  let editPath = ''

  if (path.match(/account/gi)) {
    editPath = `accountText.${accountText}.${path}`
  }
  if (path.match(/project/gi)) {
    editPath = `projectText.${projectText}.${path}`
  }

  return editPath
}

export default {
  formatBytes,
  formatCurrency,
  ellipsis,
  capitalize,
  changePath,
}
